import classNames from "classnames";
import React from "react"
import {Helmet} from "react-helmet";
import externals from "../external-links";
import styles from "../styles/main.module.css";

function Projects(props) {
	const projects = props.projects;

	if (projects.length === 0) {
		return null;
	}
	return (
		<>
			<h2>Select Projects</h2>

			<ul>
				{projects.map(function(t) {
					return <li><a href={t.url}>{t.name}</a></li>
				})}
			</ul>
		</>
	);
}

export default () =>
	<>
		<Helmet>
			<title>Stacey's Homepage</title>
		</Helmet>

		<h2>About</h2>

		<p>I'm <span className={classNames(styles.author)}>Stacey Ell</span>, a software developer currently working for Cisco Systems.  I sometimes work with <a href={externals.links.gyng_projects}>Ng Guoyou</a> on fun projects.  I think this site will mostly be a curated list of computer-related links.</p>

		<p>My main social media is <a href={externals.links.social_media_twitter}>Twitter</a>.</p>

		<h2>Stuff I found online that I like</h2>

		<h3>Tools</h3>

		<ul>
			{externals.tools.map((t) => {
				return <li><a href={t.url}>{t.name}</a></li>
			})}
		</ul>

		<h3>Uncategorized</h3>

		<ul>
			<li><a href={externals.links.blog_brendan_gregg}>Brendan Gregg's Blog</a></li>

			<li><a href={externals.links.youtube_semiconductors_magic}>Indistinguishable From Magic: Manufacturing Modern Computer Chips (2009)</a> - YouTube Video</li>

			<li><a href={externals.links.youtube_bcantrill_oral_history}>Monktoberfest 2016: Bryan Cantrill - Oral Tradition in Software Engineering (2016)</a> - YouTube Video</li>

			<li><a href={externals.links.wikipedia_the_thing}>The Thing (listening device)</a> - Wikipedia article</li>
		</ul>

		<h3>Future investigation</h3>
		<ul>
			<li>
				the BPF track
				<ul>
					<li>
						<a href="https://crates.io/crates/rbpf">the rbpf crate</a> - Virtual machine and JIT compiler for eBPF programs. (Apache-2.0/MIT)
					</li>
					<li>
						<a href="https://blogs.igalia.com/dpino/2019/01/07/a-brief-introduction-to-xdp-and-ebpf/">A brief introduction to XDP and eBPF</a>, Diego Pino García
					</li>
					<li>
						<a href="https://jvns.ca/blog/2017/06/28/notes-on-bpf---ebpf/">Notes on BPF & eBPF</a>, Julia Evans
					</li>
					<li>
						<a href="https://blogs.oracle.com/linux/notes-on-bpf-3">BPF In Depth: Communicating with Userspace</a>, Greg Marsden (Oracle)
					</li>
				</ul>
			</li>
			<li>
				<a href="https://gvisor.dev">gVisor</a> - A sandboxing container runtime
			</li>
		</ul>

		<Projects projects={externals.projects.filter(x => x.enabled)} />
	</>
